import type { CreateCampaignFormValues } from '../pages/CreateCampaignPage/createCampaignSchema';
import type { CreateCampaignParam } from '../types';

export function buildCampaignParams(
  values: CreateCampaignFormValues,
): CreateCampaignParam[] {
  const shared = {
    isrc: values.isrc,
    track_name: values.track,
    artist_name: values.artist,
    start_date: new Date(values.campaignStartDate).toISOString(),
    end_date: new Date(values.campaignEndDate).toISOString(),
    spotify_url: values.spotifyUrl,
    tiktok_audio_url: values.tiktokLink ?? '',
    instagram_audio_url: values.instagramLink ?? '',
    advertiser: values.advertiser,
    content_bank_url: '',
    asset_urls: [],
  };

  const params: CreateCampaignParam[] = [];

  if (values.clippingEnabled && values.clippingBudget) {
    params.push({
      ...shared,
      campaign_channel: 'CLIPPING',
      marketing_agency: 'CLIP_TECH',
      budget_usd_cents: Math.round(values.clippingBudget * 100),
      purchase_order: values.clippingPurchaseOrder ?? '',
    });
  }

  if (values.influencerEnabled && values.influencerBudget) {
    params.push({
      ...shared,
      campaign_channel: 'INFLUENCER',
      marketing_agency: 'PRODUCER_LABS',
      budget_usd_cents: Math.round(values.influencerBudget * 100),
      purchase_order: values.influencerPurchaseOrder ?? '',
    });
  }

  return params;
}
